import english from './languages/english'
import danish from './languages/danish'
import norwegian from './languages/norwegian'

export const supportedLanguages = ['en_UK', 'da_DK', 'nb_NO']

export const defaultLanguage = 'da_DK'

interface Translations {
  en: Record<string, string>
  da: Record<string, string>
  nb: Record<string, string>
}

const translations: Translations = {
  en: english,
  da: danish,
  nb: norwegian,
}

export default translations
